import { IdentityType } from "graphql/generated/graphql";
import { capitalizeFirstLetterRestLowercase, getListFromGraphql } from "utils/utils";

const identityTypes: IdentityType[] = getListFromGraphql("IdentityType").filter(
    (type) => type !== "LDAP_CONFIG" && type !== "WORKSPACE"
);

export const typeList = identityTypes.map((identity) => ({
    label: capitalizeFirstLetterRestLowercase(identity.replace("_", " ")),
    resourceName: identity.toLowerCase(),
}));

export const initialFilter = { identity_type: typeList.map((type) => type.resourceName) };

export const getInitialCountIri = (roleId: string) => `${roleId}-initialCount`;

// localStorage tableSettings key for the role identity list, so the page size
// persists across navigation and reload (parity with other record lists).
export const roleIdentityListKey = "roleIdentityList";
